import why1 from "assets/svg/why1.svg";
import why2 from "assets/svg/why2.svg";
import why3 from "assets/svg/why3.svg";
import why4 from "assets/svg/why4.svg";
import why5 from "assets/svg/why5.svg";

const ReliableIcon = why1;
const CapabilityIcon = why2;
const SupplyIcon = why3;
const EnterpriseIcon = why4;
const DeliveryIcon = why5;

const cards = [
  {
    title: "Reliable Talent, Ready to Deliver",
    description:
      "We focus on providing professionals who are prepared to contribute from day one.",
    icon: ReliableIcon,
  },
  {
    title: "End-to-End Capability",
    description:
      "From hiring to delivery and workforce development, all in one ecosystem",
    icon: CapabilityIcon,
  },
  {
    title: "Continuous Talent Supply",
    description:
      "Through Stacstart, we maintain a steady pipeline of skilled professionals.",
    icon: SupplyIcon,
  },
  {
    title: "Enterprise Experience",
    description:
      "We understand the expectations around security, compliance, and performance in enterprise environments",
    icon: EnterpriseIcon,
  },
  {
    title: "Delivery Focus",
    description:
      "We prioritize outcomes, ensuring talent contributes effectively to business goals.",
    icon: DeliveryIcon,
  },
];

const WhyConclase = () => {
  return (
    <div className="w-full bg-[#F0F2F5] px-6 sm:px-10 xl:px-20 py-14 xl:py-20">
      <h2 data-aos="fade-up" className="text-[28px] sm:text-[36px] xl:text-[40px] font-black text-blue-400 mb-10">
        Why Conclase?
      </h2>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-3">
        {cards.map((card, index) => (
          <div
            key={card.title}
            data-aos="fade-up"
            data-aos-delay={`${index * 100}`}
            className="flex flex-col gap-5 bg-white rounded-2xl p-7"
          >
            <img src={card.icon} alt={card.title} className="object-contain w-14 h-14" />

            <div className="flex flex-col gap-2">
              <p className="text-lg font-black leading-snug text-blue-100">
                {card.title}
              </p>
              <p className="text-sm leading-relaxed text-dark-100">
                {card.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyConclase;
